import { RouteConfig } from "vue-router";
import login from "./login";
import privateRoutes from "./private";
import publicRoutes from "./public";

export const routes: RouteConfig[] = [...login, ...publicRoutes, ...privateRoutes].sort(({ meta: a }, { meta: b }) =>
  (!a.toBottom && !b.toBottom) || (a.toBottom && b.toBottom) ? 0 : a.toBottom && !b.toBottom ? 1 : -1
);
